import { Haptics } from '@capacitor/haptics'

// Fire-and-forget, all three queued at once. Don't chain these with .then:
// selectionChanged is the call that actually vibrates (selectionStart only
// prepares/flags), and a chained callback can't run until the JS thread is
// free — i.e. after whatever heavy render the tap just kicked off, which on a
// slow device is seconds later. The bridge post itself is synchronous and the
// native side executes plugin calls in order, so ordering is preserved.
export const hapticLight = () => {
  void Haptics.selectionStart().catch(() => {})
  void Haptics.selectionChanged().catch(() => {})
  void Haptics.selectionEnd().catch(() => {})
}
